/**
 * Module Initialization
 *
 * Registers base screens with the ModuleRegistry, then layers on every screen
 * override declared by a tenant bundle under `customize/`. Imported once at
 * startup from `main.tsx`.
 *
 * Adding a tenant override is a `componentOverrides` entry in that tenant's
 * bundle -- this file never names a tenant.
 */

import React from 'react';
import { getTenantCustomizations } from '@customize/registry';
import { moduleRegistry } from './ModuleRegistry';

import { PatientDmInfoEditPage } from '@pages/main/patient';

/** Base implementations, keyed by the path the router asks for. */
function registerBaseComponents(): void {
  moduleRegistry.registerComponent('patient/PatientDmInfoEdit', () =>
    Promise.resolve({ default: PatientDmInfoEditPage as React.ComponentType<unknown> })
  );
}

/** Per-tenant replacements declared in `customize/<tenant>`. */
function registerTenantOverrides(): void {
  for (const tenant of getTenantCustomizations()) {
    for (const [path, loader] of Object.entries(tenant.componentOverrides ?? {})) {
      moduleRegistry.registerTenantOverride(path, tenant.code, loader);
    }
  }
}

registerBaseComponents();
registerTenantOverrides();
